var map = {
	"./en-CA/menu.json": "b03d",
	"./en-CA/multi_location_settings.json": "4313",
	"./en-CA/orders.json": "4a56",
	"./en-CA/rally-intelligence.json": "b6ed",
	"./en-CA/settings.json": "4e9c",
	"./en-CA/shared.json": "0cdc",
	"./en-CA/suites.json": "e9c3",
	"./en-CA/utils.json": "6570",
	"./en-GB/menu.json": "74dc",
	"./en-GB/orders.json": "8939",
	"./en-GB/settings.json": "f119",
	"./en-GB/shared.json": "8b32",
	"./en-GB/suites.json": "38d1",
	"./fr-CA/menu.json": "aaae",
	"./fr-CA/multi_location_settings.json": "21f2",
	"./fr-CA/orders.json": "c793",
	"./fr-CA/rally-intelligence.json": "0908",
	"./fr-CA/settings.json": "840d",
	"./fr-CA/shared.json": "2c4f",
	"./fr-CA/suites.json": "e3ff",
	"./fr-CA/utils.json": "2e8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";